import apiClient from '../utils/apiClient';

export const getEmailText = async (dataArray) => {
    try {
      const response = await apiClient.post('/email_txt', dataArray); 
      
      return response.data; 
    } catch (error) {
      console.error('Error al enviar email:', error.response?.data || error.message);
      throw error; 
    }
  };
  export const getEmailErrorReserva = async (dataArray) => {
    try {
      const response = await apiClient.post('/email_html_reserva_error', dataArray); 
      
      return response.data; 
    } catch (error) {
      console.error('Error al enviar email:', error.response?.data || error.message);
      throw error; 
    }
  };
  export const getEmailConfirmReserva = async (dataArray) => {
    try {
      const response = await apiClient.post('/email_html_reserva', dataArray); 
      
      return response.data; 
    } catch (error) {
      console.error('Error al enviar email:', error.response?.data || error.message);
      throw error; 
    }
  };
  export const getEmailPagoExitoso = async (dataArray) => {
    try {
      const response = await apiClient.post('/email_html_pago_exitoso', dataArray); 
      
      return response.data; 
    } catch (error) {
      console.error('Error al enviar email:', error.response?.data || error.message);
      throw error; 
    }
  };

  export const getEmailConfirmReservaPP = async (dataArray) => {
    try {
      const response = await apiClient.post('/email_html_reserva_pp', dataArray); 
      
      return response.data; 
    } catch (error) {
      console.error('Error al enviar email:', error.response?.data || error.message);
      throw error; 
    }
  };
  export const getEmailPagoExitosoPP = async (dataArray) => {
    try {
      const response = await apiClient.post('/email_html_pago_exitoso_pp', dataArray); 
      
      return response.data; 
    } catch (error) {
      console.error('Error al enviar email:', error.response?.data || error.message);
      throw error; 
    }
  };